import { CONSORS_CONSOLIDATION_ACCESS_KINDS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    id: string;
};

export const schemaLoanRequestResolver_GetConsorsConsolidationAccess = z.discriminatedUnion('kind', [
    z.object({
        accessKey: z.string().min(1),
        kind: z.literal(CONSORS_CONSOLIDATION_ACCESS_KINDS.AVAILABLE),
        token: z.string().min(1),
        url: z.string().url().startsWith('https://'),
    }),
    z.object({ expiresAt: z.coerce.date(), kind: z.literal(CONSORS_CONSOLIDATION_ACCESS_KINDS.EXPIRED) }),
    z.object({ kind: z.literal(CONSORS_CONSOLIDATION_ACCESS_KINDS.UNAVAILABLE) }),
]);

export type SchemaLoanRequestResolver_GetConsorsConsolidationAccess = z.infer<
    typeof schemaLoanRequestResolver_GetConsorsConsolidationAccess
>;

export type LoanRequestResolver_GetConsorsConsolidationAccess = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetConsorsConsolidationAccess
>;
